var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Portal",
    { attrs: { to: "modal" } },
    [
      _vm.images
        ? _c("VueEasyLightbox", {
            attrs: { visible: _vm.visible, imgs: _vm.images, index: _vm.index },
            on: { hide: _vm.handleHide },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }